import Vue from 'vue';
import Router from 'vue-router';
import { i18n } from './plugins/i18n.js';
import store from './store';
import languages from '@/config/languages';


Vue.use(Router);

const router = new Router({
  mode: 'history',
  linkExactActiveClass: 'active',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/:lang([a-z][a-z])+',
      component: {
        render(c) {
          return c('router-view');
        },
      },
      beforeEnter(to, from, next) {
        if (languages.find(item => item.name === to.params.lang.toUpperCase())) {
          i18n.locale = to.params.lang.toUpperCase();
        } else {
          i18n.locale = 'EN';
          return next('en');
        }
        return next();
      },
      children: [
        {
          path: 'login',
          name: 'login',
          beforeEnter(to, from, next) {
            const localUser = JSON.parse(window.localStorage.getItem('tentacles'));
            const vuexUser = store.getters['tentacle/token'];

            if ((!!vuexUser) === true || (localUser && localUser.token !== null)) {
              return next(from.fullPath);
            }
            return next();
          },
          component: () => import('./views/login'),
        },
        {
          path: 'server-status',
          name: 'server-status',
          component: () => import('./views/server-status'),
        },
        {
          path: 'sigfox-coverage',
          name: 'sigfox-coverage',
          component: () => import('./views/sigfox-coverage'),
        },
        {
          path: 'dashboard/:type?',
          alias: 'dashboard',
          name: 'dashboard',
          async beforeEnter(to, from, next) {
            let tentacleTypes = store.getters['tentacle/tentacles'];
            let customers = store.getters['customer/customers'];
            const customerId = window.localStorage.getItem('customerId');
            const localUser = JSON.parse(window.localStorage.getItem('tentacles'));

            // check if tentacle types are loaded, if not, load all types for current user
            if (customers && customers.length === 0) {
                await store.dispatch('customer/setCustomers');
                customers = store.getters['customer/customers'];
            }

            if (localUser.is_dealer) {
              const dealer = {
                id: 'dealer-view',
                name: 'Dealer view',
              };
              if (!customers.some(item => item.id == dealer.id)) {
                customers.unshift(dealer);
              }
            }

            let customer = customers[0];
            if (customers.length > 1) {
              customer = customers.find(item => item.id == customerId) || customer;
            }

            let tentacleListFor;
            window.localStorage.setItem('customerId', customer.id.toString());
            tentacleListFor = customer;

            await store.dispatch('customer/setCustomer', tentacleListFor);

            // check if tentacle types are loaded, if not, load all types for current user
            if (tentacleTypes && tentacleTypes.length === 0) {
              await store.dispatch('tentacle/setTentacles', tentacleListFor.id);
              tentacleTypes = store.getters['tentacle/tentacles'];
            }

            let tType = {};
            if (to.params.type !== undefined) {
              tType = tentacleTypes.find(item => (item.urlSlug === to.params.type));
              if (tType) {
                let params = {customer: tentacleListFor, type: tType};
                store.dispatch('tentacle/setType', params);
                return next();
              }
            }

            tType = store.getters['tentacle/type'];
            let tTypeSlug = (tType && tType.urlSlug) ? tType.urlSlug : store.getters['tentacle/tentacles'][0].urlSlug;
            let lang = to.params.lang;

            router.replace(`/${lang}/dashboard/${tTypeSlug}`);
          },
          component: () => import('./views/dashboard'),
        },
        {
          path: 'detail/:id?',
          alias: 'detail',
          name: 'detail',
          async beforeEnter(to, from, next) {
            if (!to.params.id) {
              return next(`/${to.params.lang}/dashboard`);
            }

            const tentacle = store.getters['tentacle/unitById'](to.params.id);
            if (!tentacle) {
              await store.dispatch('tentacle/setUnitByID', to.params.id);
            }
            return next();
          },
          component: () => import('./views/detail'),
        },
        {
          path: 'bulk-detail',
          name: 'bulk-detail',
          async beforeEnter(to, from, next) {
            let tentacleTypes = store.getters['tentacle/tentacles'];
            const localUser = JSON.parse(window.localStorage.getItem('tentacles'));

            if (!to.query.type || !to.query.ids) {
              return next(`/${to.params.lang}/dashboard`);
            }

            if (tentacleTypes && tentacleTypes.length === 0) {
                let customers = store.getters['customer/customers'];
                const customerId = window.localStorage.getItem('customerId');

                // check if tentacle types are loaded, if not, load all types for current user
                if (customers && customers.length === 0) {
                  await store.dispatch('customer/setCustomers');
                  customers = store.getters['customer/customers'];
                }

                let tentacleListFor = {};
                if (localUser.is_dealer) {
                  tentacleListFor = {
                    id: 'dealer-view',
                    name: 'Dealer view',
                  };

                  window.localStorage.setItem('customerId', tentacleListFor.id.toString());
                } else {
                  window.localStorage.setItem('customerId', customerId.toString());
                  tentacleListFor = customers[0];
                }

                await store.dispatch('customer/setCustomer', tentacleListFor);
                await store.dispatch('tentacle/setTentacles', tentacleListFor.id);
                tentacleTypes = store.getters['tentacle/tentacles'];
                let tType = tentacleTypes.find(item => item.id === Number(to.query.type));
                let params = {customer: tentacleListFor, type: tType};
                await store.dispatch('tentacle/setType', params);
            }

            return next();
          },
          component: () => import('./views/bulk-detail'),
        },
        {
          path: '',
          name: 'error404',
          beforeEnter(to, from, next) {
            return next(`${to.fullPath}/dashboard`);
          },
        },
      ],
    },
    {
      path: '/',
      beforeEnter(to, from, next) {
        return next(i18n.locale.toLowerCase());
      },
    },
    {
      path: '*',
      beforeEnter(to, from, next) {
        return next(i18n.locale.toLowerCase());
      },
    },

  ],
});

router.beforeEach((to, from, next) => {
  const localUser = JSON.parse(window.localStorage.getItem('tentacles'));
  const vuexUser = store.getters['tentacle/token'];

  if (to.name === 'login') {
    return next();
  }

  if ((!!vuexUser) === true) {
    return next();
  }

  if (localUser && localUser.token !== null) {
    store.commit('tentacle/SET_USER', localUser);
    return next();
  }

  return next('/en/login');
});

export default router;
